import { useEffect, useState, useRef } from "react";
import "./sub1.css";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga4";
import emailjs from "@emailjs/browser";
import contactConfig from "../../confi";
const Contact = () => {
  const form = useRef();
  const [loading, setLoading] = useState(false);

  const handleCall = () => {
    // Google Ads Conversion
    if (window.gtag_report_conversion) {
      window.gtag_report_conversion();
    }

    ReactGA.event({
      category: "Contact",
      action: "Clicked Call Button",
      label: "Contact Page",
    });

    window.open(`tel:${contactConfig.phone}`);
  };


  const handleWhatsApp = () => {
    // Google Ads Conversion
    if (window.gtag_report_conversion) {
      window.gtag_report_conversion();
    }

    ReactGA.event({
      category: "Contact",
      action: "Clicked WhatsApp Button",
      label: "Contact Page",
    });

    const phoneNumber = `${contactConfig.phone}`;
    const message = "Hello, I would like to know more about your services.";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    window.open(whatsappUrl, "_blank");
  };


  useEffect(() => {
    ReactGA.event({
      category: "Page View",
      action: "Visited Contact Page",
      label: "Contact Page Section",
    });
  }, []);

  // ✅ EmailJS integrated with loading + alerts
  const sendEmail = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await emailjs.sendForm(
        "service_v4bj4cq",
        "template_a7bino9",
        form.current,
        "EPURM9NpZ87StWlSC"
      );

      // 🔥 Google Ads Conversion Tracking (FORM SUCCESS)
      if (window.gtag_report_conversion) {
        window.gtag_report_conversion();
      }

      alert("✅ Message sent successfully!");
      e.target.reset();
    } catch (error) {
      console.error("FAILED...", error.text);
      alert("❌ Failed to send message. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* ------------------- SEO HELMET ------------------- */}
      <Helmet>
        <title>
          Hire Staff or Apply for Jobs | Contact Now JP Home Services
        </title>
        <meta
          name="description"
          content="Contact JP Home Services to hire verified maids, cooks & caregivers, or to apply for home service jobs in Ahmedabad & Gujarat. Call +918780438907."
        />
        <meta
          name="keywords"
          content="Contact JP Home Services, Book Maid in Ahmedabad, Hire Cook in Ahmedabad, Babysitter Booking Gujarat, Driver Service Enquiry, Patient Care Help Line Ahmedabad, Domestic Help Gujarat"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://jphomeservice.in/contact" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Hire Staff or Apply for Jobs | Contact Now JP Home Services "
        />
        <meta
          property="og:description"
          content="Contact JP Home Services to hire verified maids, cooks & caregivers, or to apply for home service jobs in Ahmedabad & Gujarat. Call +918780438907."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://jphomeservice.in/contact"
        />
        <meta
          property="og:image"
          content="https://jphomeservice.in/static/media/TRANSPARNT%20LOGO.1a150556bfeacec71cee.png"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Hire Staff or Apply for Jobs | Contact Now JP Home Services "
        />
        <meta
          name="twitter:description"
          content="Contact JP Home Services to hire verified maids, cooks & caregivers, or to apply for home service jobs in Ahmedabad & Gujarat. Call +918780438907."
        />
        <meta
          name="twitter:image"
          content="https://jphomeservice.in/static/media/TRANSPARNT%20LOGO.1a150556bfeacec71cee.png"
        />

        {/* JSON-LD */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "JP Home Services",
            "url": "https://jphomeservice.in/contact",
            "logo": "https://jphomeservice.in/static/media/TRANSPARNT%20LOGO.1a150556bfeacec71cee.png",
            "sameAs": [
              "https://www.facebook.com/jphomeservice.in/",
              "https://www.instagram.com/jp_home_service/"
            ],
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+919327365056",
              "contactType": "Customer Service"
            }
          }
          `}
        </script>
      </Helmet>

      {/* ------------------- MAIN CONTACT SECTION ------------------- */}
      <div className="main-content-wrapper">
        <div className="contact">
          <section className="contact-header">
            <div className="container">
              <h1>Contact Us</h1>
              <p>Get in touch with us for any queries or service bookings</p>
            </div>
          </section>

          {/* Floating Buttons */}
          <div className="floating-contact-icons">
            <div className="contact-icon whatsapp-icon" onClick={handleWhatsApp}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893c0-3.18-1.24-6.169-3.495-8.424" />
              </svg>
            </div>
            <div
              className="contact-icon call-icon"
              onClick={handleCall}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 10.999h2C22 5.869 18.127 2 12.99 2v2C17.052 4 20 6.943 20 10.999z" />
                <path d="M13 8c2.103 0 3 .897 3 3h2c0-3.225-1.775-5-5-5v2zm3.422 5.443a1.001 1.001 0 00-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 00.043-1.391L6.859 3.513a1 1 0 00-1.391-.087l-2.17 1.861a1 1 0 00-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 00.648-.291l1.86-2.171a1 1 0 00-.086-1.391l-4.064-3.696z" />
              </svg>
            </div>
          </div>

          {/* Contact Form + Info */}
          <section className="contact-content">
            <div className="container">
              <div className="contact-wrapper">
                {/* ✅ FORM START */}
                <div className="contact-form-section">
                  <h2>Send us a Message</h2>
                  <form
                    className="contact-form"
                    ref={form}
                    onSubmit={sendEmail}
                  >
                    <div className="form-group">
                      <label htmlFor="location">Maid in Ahmedabad</label>
                    </div>

                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        placeholder="Your Name*"
                        required
                      />
                    </div>

                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="emailid"
                        placeholder="Email Address*"
                        required
                      />
                    </div>

                    <div className="form-group">
                      <input
                        type="tel"
                        id="phone"
                        name="contactno"
                        placeholder="Phone Number*"
                        required
                      />
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <select id="category" required name="ServiceRequired">
                          <option value="">Choose a category</option>
                          <option value="House Maid">House Maid</option>
                          <option value="Baby Sitting">Baby Sitting</option>
                          <option value="Elderly Care">Elderly Care</option>
                          <option value="Patient Care">Patient Care</option>
                          <option value="Cook">Cook</option>
                          <option value="Driver">Driver</option>
                          <option value="Full Time Servant">
                            24x7 Servant
                          </option>
                          <option value="Office Boy">Office Boy</option>
                          <option value="Pet Care">Pet Care</option>
                        </select>
                      </div>
                    </div>

                    {/* <div className="form-group">
                      <textarea
                        id="message"
                        placeholder="Your Message*"
                        rows="5"
                        name="user_message"
                        required
                      ></textarea>
                    </div> */}

                    <button
                      type="submit"
                      className="submit-btn1"
                      disabled={loading}
                    >
                      {loading ? "Sending..." : "Send Message"}
                    </button>
                  </form>
                </div>

                {/* ✅ CONTACT INFO */}
                <div className="contact-info-section">
                  <h2>Get in Touch</h2>
                  <div className="contact-info">
                    <div className="info-item">
                      <div className="info-icon">📞</div>
                      <div className="info-content">
                        <h3>Phone Number</h3>
                        <p>{contactConfig.phone}</p>
                        <p>24/7 Customer Support</p>
                      </div>
                    </div>

                    <div className="info-item">
                      <div className="info-icon">✉️</div>
                      <div className="info-content">
                        <h3>Email Address</h3>
                        <p>{contactConfig.email}</p>
                      </div>
                    </div>

                    <div className="info-item">
                      <div className="info-icon">🏠</div>
                      <div className="info-content">
                        <h3>Office Address</h3>
                        <p>A-316-317, Swaminarayan Avenue,</p>
                        <p>
                          Nr. AEC Cross Road, Naranpura, Ahmedabad, Gujarat -
                          380013
                        </p>
                      </div>
                    </div>

                    <div className="info-item">
                      <div className="info-icon">⏰</div>
                      <div className="info-content">
                        <h3>Working Hours</h3>
                        <p>{contactConfig.time}</p>
                      </div>
                    </div>
                  </div>

                  <div className="emergency-contact">
                    <h3>Emergency Service</h3>
                    <div className="emergency-number">
                      <span className="emergency-icon">🚨</span>
                      <span>{contactConfig.phone}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default Contact;
